module.exports = __webpack_public_path__ + "static/media/trend-google-rev-description-cst.480b4ae2.png";